import { FeatureDTO } from "./FeatureDTO";

export class CommunicationFeatureDTO extends FeatureDTO {
    constructor(sub?) {
        super(sub);
    }
}
